import axios from '@/plugins/axios'

const state = {
    radars: [],
    foreignRadars: [],
    initialisedRadars: [],
    currentRadarId: 0,
    currentQuadrant: 4
}

// getters
const getters = {
    /**
     * get allr adars
     * @param state
     */
    getRadars: (state) => {
        return state.radars
    },

    /**
     * get radar
     * @param state
     * @returns {function(*): T}
     */
    getRadar(state) {
        return (id) => {
            return state.radars.find(r => r.id === id)
        }
    },

    getCurrentRadar(state) {
        var radar = state.radars.find(r => r.id === state.currentRadarId);

        if(radar === undefined)
            radar = state.foreignRadars.find(r => r.id === state.currentRadarId);

        return radar
    },

    getCurrentRadarId(state) {
        return state.currentRadarId
    },

    getCurrentQuadrant (state) {
        return state.currentQuadrant
    },

    isRadarInitialised(state) {
        return (id) => {
            return state.initialisedRadars.indexOf(id)  > -1
        }
    }
}

// actions
const actions = {
    /**
     * load all radars
     * @param commit
     * @returns {Promise<T>}
     */
    async loadRadars({ rootState, commit }) {
        return axios.get('/radar')
            .then((response) => {
                commit('setRadars', response.data);
            })
            .catch((error) => {
              if (rootState.user.isLoggedIn) {
                commit('error/newError', {
                  title: 'error.radar.init',
                  text: error.response? error.response.data.message || error.message: error.message
                }, { root: true });
              }
            });
    },

    async loadForeignRadar ({ commit }, id) {
        // set loader
        commit('addToLoadingQueue', 'radar_load_foreign_' + id,  { root: true });

        return axios.get('/radar/' + id)
          .then((response) => {
              commit('setForeignRadar', response.data);

              commit('removeFromLoadingQueue', 'radar_load_foreign_' + id, { root: true });
          })
          .catch((error) => {
              console.log(error)

              commit('removeFromLoadingQueue', 'radar_load_foreign_' + id, { root: true });
          });
    },

    /**
     * create radar
     * @param commit
     * @param radar
     * @returns {Promise<unknown>}
     */
    async createRadar({ commit }, radar) {
        // set loader
        commit('addToLoadingQueue', 'radar_create_new',  { root: true });

        return new Promise((resolve, reject) => {
            // send create request
            axios.post('/radar', radar)
                .then((response) => {
                    // update radar
                    commit('setRadar', response.data.radar)

                    // remove loader
                    commit('removeFromLoadingQueue', 'radar_create_new', { root: true });

                    resolve(response);
                })
                .catch((error) => {
                    // remove loader
                    commit('removeFromLoadingQueue', 'radar_create_new', { root: true });
                    // raise error
                    commit('error/newError', {
                        title: 'error.radar.create',
                        text: error.response? error.response.data.message || error.message: error.message
                    }, { root: true});

                    reject(error);
                })
        });
    },

    /**
     * update new radar
     * @param commit
     * @param radar
     * @returns {Promise<unknown>}
     */
    async updateRadar({ commit }, radar) {
        // set loader
        commit('addToLoadingQueue', 'radar_update_' + radar.id, { root: true });

        return new Promise((resolve, reject) => {
            // send update request
            axios.put('/radar/' + radar.id, radar)
                .then((response) => {
                    // update radar
                    commit('setRadar', radar)
                    // remove loader
                    commit('removeFromLoadingQueue', 'radar_update_' + radar.id, {root: true});
                    resolve(response);
                })
                .catch((error) => {
                    // remove loader
                    commit('removeFromLoadingQueue', 'radar_update_' + radar.id, {root: true});
                    // raise error
                    commit('error/newError', {
                       title: 'error.radar.update',
                        text: error.response? error.response.data.message || error.message: error.message
                    }, { root: true});
                    reject(error);
                })
        });
    },

    /**
     * remove radar
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    async removeRadar({ commit }, id) {
        // set loader
        commit('addToLoadingQueue', 'radar_delete_' + id, { root: true });

        return new Promise((resolve, reject) => {
            // send update request
            axios.delete('/radar/' + id)
                .then((response) => {

                    // update radar
                    commit('removeRadar', id);
                    // remove loader
                    commit('removeFromLoadingQueue', 'radar_delete_' + id, {root: true});

                    resolve(response);
                })
                .catch((error) => {
                    commit('error/newError', {
                        title: 'error.radar.delete',
                        text: error.response? error.response.data.message || error.message: error.message
                    }, { root: true});

                    reject(error);
                })
        });
    }
}

// mutations
const mutations = {
    /**
     * set radars
     * @param state
     * @param radars
     */
    setRadars(state, radars) {
        state.radars = radars;
    },

    setRadarInitialised(state, id) {
        state.initialisedRadars.push(id);
    },

    /**
     * set current radar id
     * @param state
     * @param id
     */
    setCurrentRadarId(state, id) {
        state.currentRadarId = id
    },

    /**
     * set/update radar
     * @param state
     * @param radar
     */
    setRadar(state, radar) {
        let pos = state.radars.findIndex(r => r.id == radar.id)

        if(pos <= -1) {
            state.radars.push(radar)
        } else {
            Object.assign(state.radars[pos], radar)
        }
    },

    setForeignRadar(state, radar) {
        let pos = state.foreignRadars.findIndex(r => r.id == radar.id)

        if(pos <= -1) {
            state.foreignRadars.push(radar)
        } else {
            Object.assign(state.foreignRadars[pos], radar)
        }
    },


    setCurrentQuadrant ( state, quadarant ) {
        state.currentQuadrant = quadarant
    },

    removeRadar(state, id) {
        let pos = state.radars.findIndex(r => r.id == id);

        if(pos > -1) {
            state.radars.splice(pos, 1);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
